import * as defaultImport from "@splunk/visualizations/Scatter";
export * from "@splunk/visualizations/Scatter";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
